export enum BroadcastPositionStage {
  ALL = 'ALL',
  OFFERED = 'OFFERED',
  PREPAYMENT = 'PREPAYMENT',
  BOOKED = 'BOOKED',
  RUNNING = 'RUNNING',
  ARCHIVED = 'ARCHIVED',
}

export interface BroadcastRouteParams {
  stage: BroadcastPositionStage;
}
